import {
  getStatementTicketsPDF,
  getStatementTicketsPDFBase64,
  getTicketsPDF,
} from '../../services/customer/ticketServices';

export default async function handleDownloadTickets(statementId, statementGuid = false) {
  if (window.ReactNativeWebView) {
    const res = await getStatementTicketsPDFBase64(statementId, statementGuid);
    window.ReactNativeWebView.postMessage(JSON.stringify({
      type: 'downloadFileFromBase64',
      data: res,
    }));

    return;
  }

  let res;
  if (statementId && statementGuid) {
    res = await getStatementTicketsPDF(statementId, statementGuid);
  } else {
    res = await getTicketsPDF(statementId);
  }

  const blob = new Blob([res], { type: 'application/pdf' });

  // Else (Web browser): create download link
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'tickets.pdf');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
